module.exports = "/virtual-football/img/video/clubs/spain/barcelona.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/spain/barcelona.png
// module id = 306
// module chunks = 6